import { render, staticRenderFns } from "./fccAdicionarProjeto.vue?vue&type=template&id=66206eb8"
import script from "./fccAdicionarProjeto.vue?vue&type=script&lang=js"
export * from "./fccAdicionarProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports